import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"
import React, { useEffect } from "react"
import Lenis from "@studio-freight/lenis"

/* =========================
onRouteUpdate
========================= */
export const onRouteUpdate = () => {
if (typeof document !== "undefined") {
const elements = document.querySelectorAll(".fadeInUp")

const observer = new IntersectionObserver(
entries => {
entries.forEach(entry => {
if (entry.isIntersecting) {
entry.target.classList.add("on")
}
})
},
{ threshold: 0.1 }
)

elements.forEach(el => observer.observe(el))
}
}

/* =========================
shouldUpdateScroll（スクロール制御専用）
========================= */
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
if (typeof window === "undefined") return false

if ("scrollRestoration" in window.history) {
window.history.scrollRestoration = "manual"
}

const lenis = window.__lenis
const { hash } = location

if (hash) {
setTimeout(() => {
const target = document.querySelector(hash)
if (!target) return
if (lenis) {
lenis.scrollTo(target, { immediate: true })
} else {
target.scrollIntoView()
}
}, 0)
} else {
setTimeout(() => {
if (lenis) {
lenis.scrollTo(0, { immediate: true })
} else {
window.scrollTo(0, 0)
}
}, 0)
}

return false
}

export const onClientEntry = () => {
if (typeof document !== "undefined") {
document.documentElement.classList.add("js")
}
}

/* =========================
Lenis Wrapper
========================= */
const WrapWithLenis = ({ element }) => {
useEffect(() => {
if (typeof window === "undefined") return

const lenis = new Lenis({
duration: 1.2,
smooth: true,
})

/* ★ window に載せる（核心） */
window.__lenis = lenis

const raf = time => {
lenis.raf(time)
requestAnimationFrame(raf)
}
requestAnimationFrame(raf)

return () => {
lenis.destroy()
window.__lenis = null
}
}, [])

return <>{element}</>
}

export const wrapPageElement = ({ element }) => {
return <WrapWithLenis element={element} />
}